<template>
  <div class="ec" v-if="list.length">
    <div class="elt-title">
      <div class="title_dian">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="txt">Hot Products</div>
    </div>
    <div class="ec-content">
      <Swipe class="my-swipe" :autoplay="100000" indicator-color="'#ddd'">
        <template v-for="(item, i) in list.slice(0, 8)">
          <SwipeItem :key="i">
            <div class="brand-list grid1-2 22" v-if="pageSize == 2">
              <div class="brand-list-one" v-for="(mode, ind) in item" :key="'c-' + ind" @click="LinkProduct(mode.id)">
                <div class="one-img">
                  <img v-if="mode.banner.length" :src="mode.banner[0]" />
                  <img v-else src="@/assets/img/empty.png" />
                </div>
                <div class="one-compname">{{ mode.name }}</div>
              </div>
              <div class="brand-list-one" v-for="(c, index) in [1, 1].splice(0, pageSize - item.length)" :key="'z' + index" v-if="item.length < pageSize"></div>
            </div>

            <div class="brand-list grid1-3" v-if="pageSize == 3">
              <div class="brand-list-one" v-for="(mode, ind) in item" :key="'c-' + ind" @click="LinkProduct(mode.id)">
                <div class="one-img">
                  <img v-if="mode.banner.length" :src="mode.banner[0]" />
                  <img v-else src="@/assets/img/empty.png" />
                </div>
                <div class="one-compname">{{ mode.name }}</div>
              </div>
              <div class="brand-list-one" v-for="(c, index) in [1, 1, 1].splice(0, pageSize - item.length)" :key="'z' + index" v-if="item.length < pageSize"></div>
            </div>

            <div class="brand-list grid2-2" v-if="pageSize == 4">
              <div class="brand-list-one" v-for="(mode, ind) in item" :key="'c-' + ind" @click="LinkProduct(mode.id)">
                <div class="one-img">
                  <img v-if="mode.banner.length" :src="mode.banner[0]" />
                  <img v-else src="@/assets/img/empty.png" />
                </div>
                <div class="one-compname">{{ mode.name }}</div>
              </div>
              <div class="brand-list-one" v-for="(c, index) in [1, 1, 1, 1].splice(0, pageSize - item.length)" :key="'z' + index" v-if="item.length < pageSize"></div>
            </div>

            <div class="brand-list grid2-3" v-if="pageSize == 6">
              <div class="brand-list-one" v-for="(mode, ind) in item" :key="'c-' + ind" @click="LinkProduct(mode.id)">
                <div class="one-img">
                  <img v-if="mode.banner.length" :src="mode.banner[0]" />
                  <img v-else src="@/assets/img/empty.png" />
                </div>
                <div class="one-compname">{{ mode.name }}</div>
              </div>
              <div class="brand-list-one" v-for="(c, index) in [1, 1, 1, 1, 1, 1].splice(0, pageSize - item.length)" :key="'z' + index" v-if="item.length < pageSize"></div>
            </div>
          </SwipeItem>
        </template>
      </Swipe>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from "vant";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "video-list",
  props: {
    rule: {
      type: Object,
      default: {
        lineRule: [
          { value: "1/2", label: "1行2列" },
          { value: "1/3", label: "1行3列" },
          { value: "2/2", label: "2行2列" },
          { value: "2/3", label: "2行3列" },
        ],
        line: "1/2", // 1/3 1行三列； 1/4 1行四列； 2/3 2行3列；2/4 2行4列
      },
    },
  },
  data() {
    return {
      pageSize: 2,
      list: [],
    };
  },
  components: {
    Swipe,
    SwipeItem,
  },
  created() {
    this.init();
    this.setRow();
  },
  computed: {
    ...mapGetters({
      exonId: "getExhibitionId",
      exhibitionConfig: "getExhibitionConfig",
    }),
    exhibitionId() {
      return this.$route.params.id || this.exonId;
    },
  },
  methods: {
    ...mapActions({
      graphqlPost: "en/graphqlPostByZXS",
      LinkProduct: "linkTo/LinkProduct",
    }),
    setRow() {
      switch (this.rule.line) {
        case "1/2":
          this.pageSize = 2;
          break;
        case "1/3":
          this.pageSize = 3;
          break;
        case "2/2":
          this.pageSize = 4;
          break;
        case "2/3":
          this.pageSize = 6;
          break;
        default:
          this.pageSize = 2;
          break;
      }
    },
    async init() {
      let query = `
        query($query:QueryInput!){
          productQuery{
            query(query:$query){
              hasNextPage
              indexFrom
              pageIndex
              pageSize
              items{
                banner
                id
                name
                isShow
              }
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
        NotEqual: {
          n: "topic",
          v: 0,
        },
        Equal_isShow: {
          n: "isShow",
          v: 1,
        }
      };
      let order = [
        {
          N: "topic",
          v: 0,
        },
        {
          N: "topicIndex",
          v: 0,
        },
      ];
      let opt = {
        query: query,
        variables: {
          query: {
            page: 1,
            size: 24,
            where: JSON.stringify(where),
            order: JSON.stringify(order),
          },
        },
      };
      let data = await this.graphqlPost(opt);
      let res = JSON.parse(JSON.stringify(data.data.productQuery.query));
      let ExArr = [];
      res.items.forEach((e, i) => {
        const c = Math.floor(i / this.pageSize);
        if (!ExArr[c]) {
          ExArr[c] = [];
        }
        if (e.banner) {
          e.banner = JSON.parse(e.banner);
        } else {
          e.banner = [];
        }
        ExArr[c].push(e);
      });
      this.list = ExArr;
    },
  },
};
</script>

<style lang="scss" scoped>
.ec {
  background: #fff;
  margin-bottom: 15px;
  padding: 0 0.3rem;
  .elt-title {
    padding: 0.25rem 0;
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    color: #333;
    .title_dian {
      display: flex;
      justify-content: space-between;
      width: 0.06rem;
      height: 0.24rem;
      flex-direction: column;
      margin-right: 0.1rem;
      span {
        width: 0.06rem;
        height: 0.06rem;
        display: block;
        border-radius: 0.02rem;
        background-image: linear-gradient(90deg, #ff4b1b 0%, #fe781d 100%), linear-gradient(#108ee9, #108ee9);
        &:nth-child(1) {
          opacity: 0.5;
        }
        &:nth-child(2) {
          opacity: 0.75;
        }
      }
    }
    img {
      width: 13px;
    }
    .txt {
      font-size: 0.3rem;
      font-weight: bold;
    }
  }
  &-content {
    padding: 0 0 0.3rem;
    background: #fff;
    width: 100%;
    .my-swipe {
      width: 100%;
      .pro_wrap {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: -0.3rem;
        &.minH28 {
          min-height: 5.3rem;
        }
        .pro_div {
          width: 30%;
          height: 2.51rem;
          margin: 0 5% 0.3rem 0;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          &:nth-child(3n + 3) {
            margin-right: 0;
          }
          .img_div {
            position: relative;
            width: 100%;
            height: 0;
            padding-top: 100%;
            img {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              display: block;
              border-radius: 0.05rem;
              border: 1px solid #f7f7f7;
            }
          }
          p {
            color: #333;
            font-size: 0.24rem;
          }
        }
      }
      .brand-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 2px 5px;
        &-one {
          background-color: #fff;
          margin-bottom: 0.1rem;
          position: relative;
          .one-img {
            border-radius: 3px;
            width: 100%;
            position: relative;
            padding-bottom: 100%;
            img {
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
            }
          }
          .one-compname {
            margin-top: 0.14rem;
            color: #333;
            font-size: 0.24rem;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
.my-swipe {
  ::v-deep {
    .van-swipe__indicators {
      bottom: 1px;
    }
    .van-swipe__indicator {
      background-color: #ddd;
    }
    .van-swipe__indicator--active {
      background-color: #fe781d;
    }
    .van-swipe__track {
      padding-bottom: 0.3rem;
    }
  }
}

.grid1-2,
.grid2-2 {
  .brand-list-one {
    width: 48%;
  }
}
.grid1-3,
.grid2-3 {
  .brand-list-one {
    width: 30%;
  }
}
</style>
